module.exports = __webpack_public_path__ + "static/media/west.cf60d883.png";